<script>
export default {
  name: "SettingsBase",
};
</script>

<template>
  <router-view />
</template>
